import React, { useContext, useEffect, useMemo } from "react";
import { observer } from "mobx-react";
import { EventContext } from "@gp/components";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { useRootAppStore } from "@hooks";
import BetsList from "@features/my-bets/mobile/my-bets-page/list/BetsList";
import { AutoSellConfirmationModal } from "@features/my-bets/mobile/common/modals/autosell-confirmation-modal";
import CashoutCounterModal from "@features/my-bets/mobile/common/modals/CashoutCounterModal";
import ShareBetSlipModal from "@features/my-bets/mobile/common/modals/ShareBetSlipModal";
import { EventContentSkeleton } from "./EventContentSkeleton";

export const MyBetsBody = observer(function MyBetsBody() {
	const rootStore = useRootAppStore();
	const event = useContext(EventContext);

	const myBetsStore = useMemo(
		() => new MyBetsStore(rootStore, "AdditionalOffer"),
		[]
	);

	useEffect(() => {
		//@ts-expect-error
		myBetsStore.fetchAdditionalOffers(event.id);
		return () => {
			myBetsStore.onDispose();
		};
	}, []);

	if (myBetsStore.isLoading) {
		return <EventContentSkeleton />;
	}

	if (
		!myBetsStore.isStoreInitialized ||
		myBetsStore.loader.isLoadingProcess
	) {
		return null;
	}

	return (
		<div className="u-mar--top--small">
			<MyBetsStoreContext.Provider value={myBetsStore}>
				<CashoutCounterModal />
				<ShareBetSlipModal />
				<BetsList />
				<AutoSellConfirmationModal />
			</MyBetsStoreContext.Provider>
		</div>
	);
});
